var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRadioUnchecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  x: 0.5,
  y: 1,
  fill: "#fff",
  stroke: "#4D4D4D",
  rx: 8.5
})));
export default SvgIcRadioUnchecked;